export const RELOAD_KEY = 'hire-go:unrecognized-action-reload';

export function hasReloadedForBuild(): boolean {
  try {
    return (
      sessionStorage.getItem(RELOAD_KEY) ===
      (process.env.NEXT_PUBLIC_WAVE_GIT_COMMIT_SHA ?? '')
    );
  } catch {
    return false;
  }
}
